import SliderBarDemo from './SliderBarDemo'

export default SliderBarDemo
// eslint-disable-next-line import/export
export * from './SliderBarDemo'
